export default {
  enterpriseCrewId: null,
  crew: {},
  labors: []
};